import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledErrorContent } from '../access/AgeGated.style';
import { ExclamationTriangleFilledIcon, Text } from '@eds-web/react';

interface ErrorViewProps {
    status?: number;
}

export const ErrorView: React.FC<ErrorViewProps> = ({ status }) => {
    const { t } = useTranslation();
    return (
        <StyledErrorContent>
            <div className="alert-icon">
                <ExclamationTriangleFilledIcon size={64} color={'critical'} />
            </div>
            <Text variant={'headingLG'} style={{ textAlign: 'center' }}>
                {t('epic.esport.error.title', { status })}
            </Text>
        </StyledErrorContent>
    );
};
